import { db } from '@/db'
import Dexie, { Table, liveQuery } from 'dexie';
import { DataSafe } from "@/models/DataSafe";

export interface ISystemToDo {
    id?: number;
    appUser: string;
    what: string;
    with: string;
  }

/**
 * System Helping Elements like:
 * what: insertRowOnServer -> row without ServerId, needs insert on Server and update here with ServerId
 * what: updateRowOnServer -> take my-datasafe-id out of with and make a value update in server-db (to ServerId out of row in datasafe)
 */

export class SystemToDo implements ISystemToDo {
    systemToDo!: Dexie.Table<ISystemToDo, number>;
    id!: number;
    appUser: string;
    what: string;
    with: string;
  
    constructor(appUser: string, what: string, with_values: string, id?:number) {
      this.appUser = appUser;
      this.what = what;
      this.with = with_values;
      if (id) this.id = id;
    }

    static async addToToDo(appUser: string, toWhat: string,val: any){
        //console.log(toWhat)
        return await 
            db.systemToDo.add({
                appUser: appUser,
                what: toWhat,
                with: val,
              })
    }

    static async getToToDo(appUser: string){
        // ToDo: checks to AppUser model
        if(typeof appUser == 'undefined'){
            return false;
        }
        if(appUser.length < 8){
            return false;
        }
        return await db.systemToDo.where("appUser").equals(appUser).toArray().then((res) => {
                let ret = {};
                if(res.length > 0){
                    for(var i=0; i < res.length; i++){
                        let rowToId = res[i]["with"];
                        /*@ts-ignore*/
                        if(typeof ret[rowToId] == 'undefined'){
                            /*@ts-ignore*/
                            ret[rowToId] = [];
                        }
                        /*@ts-ignore*/
                        ret[rowToId].push(res[i]);
                        
                    }
                }
                //console.log(ret)
                return ret
            })
        
    }

    static async deleteToDo(id: number){
        //console.log(id)
        return await db.systemToDo.where("id").equals(id).delete();
    }

    static async cleanUpToDos(appUser: string){
        SystemToDo.getToToDo(appUser).then((todos) => {
            let DataSafeIds = Object.keys(todos);
            if(DataSafeIds.length > 0){
                //console.log(todos);
                DataSafe.getAllIds(DataSafeIds).then((foundToIds) => {
                    
                    if(foundToIds.length >0){
                        for(var t=0; t < foundToIds.length;t++){
                            
                            /*@ts-ignore*/
                            if(typeof foundToIds[t] == 'undefined'){
                                 /*@ts-ignore*/
                                 //console.log(todos[DataSafeIds[t]][0]["id"]);
                                 /*@ts-ignore*/
                                SystemToDo.deleteToDo(todos[DataSafeIds[t]][0]["id"]); 
                            }
                        }
                    }
                    
                });
            }
        });
        
    }

    static async cleanUpMyToDoRows(myTodoRows: any){
        if(myTodoRows.length > 0){
            let toHandle = Object.keys(myTodoRows);
            for(var i = 0; i < toHandle.length; i++){
                /*@ts-ignore*/
                SystemToDo.deleteToDo(myTodoRows[toHandle[i]][0]["id"]); 
            }

        }
    }

}